import { render } from "./my-layout.vue?vue&type=template&id=2f6cb689"
import script from "./my-layout.vue?vue&type=script&lang=js"
export * from "./my-layout.vue?vue&type=script&lang=js"

import "./my-layout.vue?vue&type=style&index=0&id=2f6cb689&lang=css"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__